import React, { useEffect, useMemo } from 'react';
import awardPrizeService from 'lib/services/awardPrizeService';
import { useLotteryPrizeStore } from 'lib/store/lotteryPrizeStore';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import PrizeInfoCard from '../PrizeInfoCard';
import { showIndependentModal } from '../Modal';
import IndependentDialog from '../IndependentDialog';
import './index.scss';

interface LotteryResultDialogProps {
  showAll?: boolean;
  showConfirmButton: boolean;
  title: string;
  confirmButtonText?: string;
  closeModal?: () => void;
}

const LotteryResultDialog = ({
  showAll = false,
  showConfirmButton = false,
  title,
  confirmButtonText,
  closeModal,
}: LotteryResultDialogProps) => {
  const [showAllPrize, setShowAllPrize] = React.useState(showAll);
  // 已翻开的奖品数量
  const [numbersOfDraws, setNumbersOfDraws] = React.useState(0);
  const {
    receivedPrizes,
    lotteryActId: actId,
    queryLotteryPrizeResult,
    currentReceivedPrizes:
    currentPrizeList,
  } = useLotteryPrizeStore(state => state,);

  const receivedCallback = () => {
    setTimeout(() => {
      queryLotteryPrizeResult();
    }, 500);
  };

  // 这里的逻辑应该区分开，原来抽奖结果跟抽奖记录是一样的，现在抽奖结果是单次的，抽奖记录是多次的
  const prizeList = useMemo(
    () => (showAll ? receivedPrizes : currentPrizeList),
    [showAll, receivedPrizes, currentPrizeList]
  );
  const receiveAward = (prizeInfo) => {
    awardPrizeService.receiveMultipleLotteryGift({ ...prizeInfo, actId }, receivedCallback);
  };

  useEffect(() => {
    if (numbersOfDraws === currentPrizeList.length) {
      setShowAllPrize(true);
    }
  }, [numbersOfDraws]);

  return (
    <IndependentDialog
      confirmButtonText={showAllPrize ? '我知道了' : confirmButtonText}
      confirmCallback={() => {
        if (!showAllPrize) {
          report(ATTA_REPORT.MULTIPLE_LOTTERY.LOTTERY_SHOW_ALL_REWARDS);
        }
        setShowAllPrize(true);
      }}
      title={title}
      closeOnConfirm={!!showAllPrize}
      closeModal={closeModal}
      showConfirm={showConfirmButton}
    >
      {prizeList?.length ? (
        <div className="lottery-result-dialog">
          <div className="deliver-tips">点击已翻开的奖励图可查看/领奖哦～</div>
          <div className="prize-list">
            {prizeList.map((item, index) => (
              <PrizeInfoCard
                key={index}
                prizeInfo={item}
                showAllPrize={showAllPrize}
                onLotteryDraw={() => {
                  setNumbersOfDraws(numbersOfDraws + 1);
                }}
                receiveAward={receiveAward}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="empty-dialog">
          <img
            className="empty-dialog__icon"
            src="https://act.ecovision.gtimg.com/static/imgs/static/static_1720144820422.png"
            alt="[图片]"
          />
          <div>空空如也</div>
          <div>快去参与一下～</div>
        </div>
      )}
    </IndependentDialog>
  );
};

export const showLotteryResultDialog = ({ showAll = false, showConfirmButton, title, confirmButtonText = '确定' }) => showIndependentModal(
  <LotteryResultDialog
    showAll={showAll}
    showConfirmButton={showConfirmButton}
    title={title}
    confirmButtonText={confirmButtonText}
  />,
  { onBottom: false },
);
